import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import UnifiedHeader from './UnifiedHeader';
import Footer from './Footer';

const BlogLayout: React.FC = () => {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <div className="relative bg-background text-foreground font-sans antialiased min-h-screen">
      <div className="relative">
        <UnifiedHeader />
        
        <main className="min-h-screen">
          {/* This is where the blog content will be rendered */}
          <Outlet />
        </main>
        
        <Footer />
      </div>
    </div>
  );
};

export default BlogLayout;
